import propertyItemModel from '../models/properyItem';
import introduceYourselfApi from '../api/introduceYourselfApi';

class IntroduceYourselfService {
  loadPersonality(params) {
    return introduceYourselfApi
      .loadPersonality(params)
      .then(res => {
        if (res.success) {
          res.data.items = propertyItemModel.mappingObjects(res.data.items);
          // let propertyItems = propertyItemModel.mappingObjects(res.data.items);
          // let categoryTab = new categoryTabModel();
          // categoryTab.data = propertyItems;
          // let categoryData = Object.assign({}, params);
          // categoryData.contentTabs = [categoryTab];
          // return categoryModel.mappingObject(categoryData);
        } else {
          console.log('ERROR: IntroduceYourselfService/loadPersonality:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: IntroduceYourselfService/loadPersonality:', e);
        throw new Error('failed');
      });
  }

  loadLooks(params) {
    return introduceYourselfApi
      .loadLooks(params)
      .then(res => {
        if (res.success) {
          res.data.items = propertyItemModel.mappingObjects(res.data.items);
          // let propertyItems = propertyItemModel.mappingObjects(res.data.items);
          // let categoryTab = new categoryTabModel();
          // categoryTab.data = propertyItems;
          // let categoryData = Object.assign({}, params);
          // categoryData.contentTabs = [categoryTab];
          // return categoryModel.mappingObject(categoryData);
        } else {
          console.log('ERROR: IntroduceYourselfService/loadLooks:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: IntroduceYourselfService/loadLooks:', e);
        throw new Error('failed');
      });
  }

  loadInterests(params) {
    return introduceYourselfApi
      .loadInterests(params)
      .then(res => {
        if (res.success) {
          res.data.items = propertyItemModel.mappingObjects(res.data.items);
          // let propertyItems = propertyItemModel.mappingObjects(res.data.items);
          // let categoryTab = new categoryTabModel();
          // categoryTab.data = propertyItems;
          // let categoryData = Object.assign({}, params);
          // categoryData.contentTabs = [categoryTab];
          // return categoryModel.mappingObject(categoryData);
        } else {
          console.log('ERROR: IntroduceYourselfService/loadInterests:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: IntroduceYourselfService/loadInterests:', e);
        throw new Error('failed');
      });
  }

  loadProfileBuilderLookingForData(params) {
    return introduceYourselfApi
      .loadProfileBuilderLookingForData(params)
      .then(res => {
        if (res.success) {
          // let propertyItems = propertyItemModel.mappingObjects(res.data.items);
          // let categoryTab = new categoryTabModel();
          // categoryTab.data = propertyItems;
          // let categoryData = Object.assign({}, params);
          // categoryData.contentTabs = [categoryTab];
          // return categoryModel.mappingObject(categoryData);
          res.data.items = propertyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: IntroduceYourselfService/loadProfileBuilderLookingForData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: IntroduceYourselfService/loadProfileBuilderLookingForData:', e);
        throw new Error('failed');
      });
  }
}

export default new IntroduceYourselfService();
